export function urlBase64ToUint8Array(base64: string) {
  const padding = "=".repeat((4 - (base64.length % 4)) % 4);
  const base64Safe = (base64 + padding).replace(/-/g, "+").replace(/_/g, "/");
  const raw = atob(base64Safe);
  const output = new Uint8Array(raw.length);
  for (let i = 0; i < raw.length; ++i) output[i] = raw.charCodeAt(i);
  return output;
}

export const VAPID_PUBLIC_KEY =
  "BJJIWsUDhNda_Q02Wro9XM5SYFAMpoFCSMtWOk-CgGttFYzttp59s7DolQMGdR7RHC6DlhiY2P8g7nebRHv5Pds";

export async function watchNotificationPermission(
  onDenied: () => void,
  onGranted?: () => void,
) {
  if (!("permissions" in navigator)) return;

  console.log("checking notification permissions");

  try {
    const handle = await navigator.permissions.query({ name: "notifications" });
    let newPermission: NotificationPermission | null = null;
    if (handle.state === "prompt") {
      newPermission = await Notification.requestPermission();
    }
    const update = () => {
      if (handle.state === "denied" || newPermission === "denied") onDenied();
      else if (
        (handle.state === "granted" || newPermission === "granted") &&
        onGranted
      )
        onGranted();
    };
    handle.addEventListener("change", update);
    update();
  } catch {
    // Not supported on all browsers (notably iOS Safari).
  }
}

export async function ensurePushSubscribed(userToken: string) {
  if (!("serviceWorker" in navigator) || !("PushManager" in window))
    return null;

  const permission = await Notification.requestPermission();
  if (permission !== "granted") return null;

  const reg = await navigator.serviceWorker.ready;
  const sub = await reg.pushManager.getSubscription();

  if (sub) return sub;

  const publicKey = VAPID_PUBLIC_KEY;
  const newSub = await reg.pushManager.subscribe({
    userVisibleOnly: true,
    applicationServerKey: urlBase64ToUint8Array(publicKey),
  });

  await fetch(`${import.meta.env.VITE_BASE_URL}/api/push/subscribe`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${userToken}`,
    },
    body: JSON.stringify(newSub),
  });

  return newSub;
}

export async function ensurePushUnsubscribed(userToken: string) {
  if (!("serviceWorker" in navigator)) return;

  console.log("revoked notifications permissions");

  const registration = await navigator.serviceWorker.ready;
  const subscription = await registration.pushManager.getSubscription();
  if (!subscription) return;

  // Tell backend to stop sending push to this endpoint
  await fetch(`${import.meta.env.VITE_BASE_URL}/api/push/unsubscribe`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${userToken}`,
    },
    body: JSON.stringify({ endpoint: subscription.endpoint }),
  }).catch((error) => {
    console.log(error);
  });

  try {
    await subscription.unsubscribe();
  } catch (error) {
    console.log(error);
  }
}
